import { Constants } from '@obo-app/constants';

export class AdminNavElement {
    public name: string;
    public key: string; // translatekey
    public uiSref: string;
    public roles?: Constants.Role[];
    public description: string;
    public icon?: string[];
}

export class Culture {
    id: number;
    name: string;
    displayName: string;
    modificationDate: Date | string;
    modules: { isActive: boolean; name: string; id: number }[];
}

export class ExcelExportResponse {
    public blob: any;
    public name: string;
}

export class ProductModel {
    id: string;
    itemNumber: number;
    name: string;
    labelOne: string;
    labelTwo: string;
    modificationDate: string;
    isActive: boolean;
    values: ProductValueModel[];
    regions: ProductRegionModel[];
}

export class ProductValueModel {
    id: string;
    attributeId: number;
    attributeName: string;
    valueId: number | null;
    value: string;
}

export class ProductRegionModel {
    name: string;
    price?: number;
    currency: string;
    priority?: number;
    releaseDate?: Date;
    isPriceUsed: boolean;
    isPriceVisible: boolean;
}

export enum CartType {
    Unknown = 0,
    Elbridge = 1,
    Download = 2
}

export class Cart {
    id: string;
    email: string;
    moduleName: string;
    itemRange: string;
    cartType: CartType;
    creationDate: Date;
    items: CartItem[];
}

export class CartItem {
    id: string;
    itemNumber: string;
    typeDescription: string;
    quantity: number;
    retailQuantity: number;
    price?: number;
    totalPrice?: number;
    unitOfQuantity: string;
    unitOfPrice: string;
}
